import { Inject, Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class AppConfig {

  private configuration: IAppConfig = null;
  private env:    Object = null;

  constructor(private http: HttpClient) {

  }



  public loadAppConfig() {
    // const jsonFile = 'assets/config/tsconfig.json';
    // return new Promise<void>((resolve, reject) => {
    //   this.http.get(jsonFile).toPromise().then((response) => {
    //     this.configuration = <IAppConfig>response;
    //     resolve();
    //   }).catch((response: any) => {
    //     reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
    //   });
    // });
  }
}

export interface IAppConfig {
  apiUrl: string;
}
